export const locale = {
    lang: 'en',
    data: {
        'MENU': {
            'MY_PROFILE' : 'My profile',
            'LOGOUT' : 'Logout'
        }
    }
};